import React from 'react';
import { Strip } from '../../Models/Article';
import { Thumbnail } from '../../Models/Thumbnail';
import { Link } from '../../Devon/Components/InkyLink';
import SeriesPoster from '../KodanshaUIKit/SeriesPoster/SeriesPoster';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import KodanshaOffers from '../KodanshaOffers/KodanshaOffers';
import './SpotlightSeriesStrip.scss';

interface Params {
    title: string;
    subTitle: string;
    items: Item[];
}

interface Item {
    informationNote: string;
    author: string;
    seriesTitle: string;
    readableUrl: string;
    linkText: string;
    linkUrl: string;
    thumbnail: Thumbnail;
}

export function SpotlightSeriesStrip({ strip: { params } }: { strip: Strip }) {
    if (!params) {
        return (
            <div className='SpotlightSeriesStrip'>
                <KodanshaOffers />
            </div>
        );
    }
    const { title, subTitle, items } = params as Params;
    return (
        <div className='SpotlightSeriesStrip'>
            <h3>{subTitle}</h3>
            <h2>{title}</h2>
            <div className='SpotlightSeries-list'>
                {items.map((item, i) => (
                    <div key={i} className='SpotlightSeries-item'>
                        <div className='SpotlightSeries-image'>
                            <Link to={`/series/${item.readableUrl}`}>
                                <SeriesPoster
                                    preloadImage={true}
                                    ratio={60}
                                    src={item.thumbnail.url ?? ''}
                                    color={item.thumbnail.color}
                                    alt={item.seriesTitle}
                                    s={{ width: 366 }}
                                    m={{ width: 339 }}
                                    l={{ width: 440 }}
                                    xl={{ width: 692 }}
                                />
                            </Link>
                            <div className='SpotlightSeries-informationNote'>
                                {item.informationNote}
                            </div>
                        </div>
                        <div className='SpotlightSeries-itemFooter'>
                            <div className='SpotlightSeries-itemFooterLeft'>
                                <Link
                                    to={`/series/${item.readableUrl}`}
                                    className='SpotlightSeries-titleLink'
                                >
                                    {item.seriesTitle}
                                </Link>
                                <Link
                                    to={`/series/${item.readableUrl}`}
                                    className='SpotlightSeries-authorLink'
                                >
                                    By {item.author}
                                </Link>
                            </div>
                            <div className='SpotlightSeries-itemFooterRight'>
                                <Link
                                    to={item.linkUrl}
                                    className='SpotlightSeries-arrowLink'
                                >
                                    <KodanshaArrow text={item.linkText} />
                                </Link>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
